"use client";

import { CartItem, NearbyShowsTicketType } from "./types";
import { ticketTypes } from "./const";
import { FastCheckoutConfirmation } from "./Confirmation";
import { PaymentAndBilling } from "./PaymentAndBilling";
import { PurchaseCompleted } from "./PurchaseCompleted";
import { PurchaseFailed } from "./PurchaseFailed";
import { Tickets } from "./Tickets";
import { Dispatch, SetStateAction, useState } from "react";

import { ModalOrDrawer } from "../../common/ModalOrDrawer";
import { ShowInfo } from "@punchup/data/legacy";

interface Props {
  show: ShowInfo;
  comedianNames: string[];
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
}

export function FastCheckoutModalOrDrawer({
  show,
  comedianNames,
  isOpen,
  setIsOpen,
}: Props) {
  const [cart, setCart] = useState<CartItem[]>(
    ticketTypes.map((t) => ({ ...t, quantity: 0 }))
  );
  const [activeStep, setActiveStep] = useState<number>(0);
  const [success, setSuccess] = useState<boolean>(false);

  const onAddClick = (ticketType: NearbyShowsTicketType) => {
    setCart((prev) =>
      prev.map((item) =>
        item.id === ticketType.id
          ? { ...item, quantity: item.quantity + 1 }
          : item
      )
    );
  };

  const onRemoveClick = (ticketType: NearbyShowsTicketType) => {
    setCart((prev) =>
      prev.map((item) =>
        item.id === ticketType.id && item.quantity > 0
          ? { ...item, quantity: item.quantity - 1 }
          : item
      )
    );
  };

  const onOpenChange = (open: boolean) => {
    setIsOpen(open);

    // if we are closing the modal, reset the state
    if (open === false) {
      // reset cart
      setCart(ticketTypes.map((t) => ({ ...t, quantity: 0 })));
      // reset step to 0
      setActiveStep(0);
    }
  };

  const closeModal = () => onOpenChange(false);
  const returnToFirstStep = () => setActiveStep(0);

  return (
    <ModalOrDrawer
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      className="p-0 px-0 pb-0 pt-4 md:p-0"
    >
      {activeStep === 0 && (
        <Tickets
          show={show}
          cart={cart}
          comedianNames={comedianNames}
          activeStep={activeStep}
          setActiveStep={setActiveStep}
          onAddClick={onAddClick}
          onRemoveClick={onRemoveClick}
        />
      )}
      {activeStep === 1 && (
        <PaymentAndBilling
          show={show}
          cart={cart}
          comedianNames={comedianNames}
          activeStep={activeStep}
          setActiveStep={setActiveStep}
        />
      )}
      {activeStep === 2 && (
        <FastCheckoutConfirmation
          show={show}
          cart={cart}
          comedianNames={comedianNames}
          activeStep={activeStep}
          setActiveStep={setActiveStep}
          setSuccess={setSuccess}
        />
      )}
      {activeStep === 3 &&
        (success ? (
          <PurchaseCompleted onButtonClick={closeModal} />
        ) : (
          <PurchaseFailed onButtonClick={returnToFirstStep} />
        ))}
    </ModalOrDrawer>
  );
}
